import { ShieldAlert } from 'lucide-react'
import type { CategoryState, ExtractedRiskItem } from '@/types/extraction'
import { OverviewStatTile } from '@/components/overview/OverviewStatTile'
import { effectiveRiskSeverity } from '@/lib/risk-severity'
import { isRanAndEmpty } from '@/stores/extraction-store'

export function RiskSnapshot({
  bidId,
  items,
  categoryState,
  loading,
}: {
  bidId: string
  items: ExtractedRiskItem[]
  categoryState: CategoryState
  loading?: boolean
}) {
  const total = items.length
  // Effective severity, matching the register's own stats strip: a critical
  // risk the team has mitigated down to low is no longer what the overview
  // should be shouting about.
  const elevated = items.filter((r) => {
    const severity = effectiveRiskSeverity(r)
    return severity === 'critical' || severity === 'high'
  }).length
  // Use the shared selector rather than re-deriving "ran and found nothing"
  // inline, so this copy can never disagree with the tab-collapse decision in
  // AnalysisSection or the empty state in ExtractionTable.
  const ranAndEmpty = isRanAndEmpty(categoryState)

  const settledSub = total > 0 ? `${elevated} high / critical` : ranAndEmpty ? 'Nothing found' : 'Not analysed yet'

  return (
    <OverviewStatTile
      icon={ShieldAlert}
      label="Risks"
      value={total}
      // `loading` only gates the tile's value, so the sub line has to be held
      // back here too — mid-run the counts are still zero and the tile would
      // otherwise claim a verdict while the analysis is still finding out.
      sub={loading ? undefined : settledSub}
      to={`/app/bids/${bidId}/qualify?view=risk_register`}
      loading={loading}
    />
  )
}
